import PropTypes from 'prop-types';
import SchemaBrowserColumn from "./column";

export default class SchemaBrowserMetaColumn extends SchemaBrowserColumn {
    getLabel() {
        const {column} = this.props;
        return this.props.label + ' ' + column.table.title_name;
    }

    onHover() {}

    render() {
        const {column} = this.props;
        // don't render if table doesn't have PK - could be the case during a search
        return column ? super.render() : null;
    }
}

SchemaBrowserMetaColumn.propTypes = {
    label: PropTypes.string.isRequired,
};
